import React from 'react';
import { Modal, Space, Alert, Typography, Select, Tag } from 'antd';
import { SourceScene } from '../../../types';

const { Text } = Typography;

interface PlanVisualsModalProps {
  visible: boolean;
  onCancel: () => void;
  scene: SourceScene | null;
  strategy: 'ALL_IMAGE' | 'ALL_VIDEO' | 'AUTO_MIX';
  onStrategyChange: (val: 'ALL_IMAGE' | 'ALL_VIDEO' | 'AUTO_MIX') => void;
  onConfirm: () => void;
  loading: boolean;
}

const PlanVisualsModal: React.FC<PlanVisualsModalProps> = ({
  visible,
  onCancel,
  scene,
  strategy,
  onStrategyChange,
  onConfirm,
  loading,
}) => {
  return (
    <Modal
      title="Đạo diễn hình ảnh (Visual Planning)"
      open={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Bắt đầu lập kế hoạch"
      cancelText="Hủy"
      confirmLoading={loading}
      width={500}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Alert
          message="AI sẽ đóng vai trò Đạo diễn hình ảnh"
          description="Dựa trên dàn ý đã có, AI sẽ mô tả chi tiết hình ảnh, góc máy và quyết định loại media cho từng panel để đảm bảo tính điện ảnh và liền mạch."
          type="info"
          showIcon
        />
        <div>
          <Text strong>Chiến lược Media cho Scene: <Text type="danger">{scene?.title}</Text></Text>
          <Select
            value={strategy}
            onChange={onStrategyChange}
            style={{ width: '100%', marginTop: 8 }}
            size="large"
            options={[
              {
                value: 'AUTO_MIX',
                label: (
                  <Space>
                    <Tag color="purple">🤖 Auto Mix</Tag>
                    <Text>AI tự quyết định (Ưu tiên những cảnh hành động)</Text>
                  </Space>
                ),
              },
              {
                value: 'ALL_IMAGE',
                label: (
                  <Space>
                    <Tag color="cyan">🖼️ All Image</Tag>
                    <Text>Toàn bộ panels là ảnh tĩnh</Text>
                  </Space>
                ),
              },
              {
                value: 'ALL_VIDEO',
                label: (
                  <Space>
                    <Tag color="volcano">🎬 All Video</Tag>
                    <Text>Toàn bộ panels sẽ là video</Text>
                  </Space>
                ),
              },
            ]}
          />
        </div>
      </Space>
    </Modal>
  );
};

export default PlanVisualsModal;
